// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app .areas .rec .rec-pagination {
  display: none;
  margin-top: -2%;
  padding-bottom: 4%;
}
.app .icons {
  transition: opacity 0.6s ease-in;
  padding-bottom: 10px;
  margin-top: -19%;
  overflow: hidden;
  display: none;
  padding: 4%;
  opacity: 0;
}
.app .icons li {
  width: 50%;
  float: left;
}
.app .icons li .item {
  background-color: #caa36c;
  border-radius: 10px;
  position: relative;
  display: block;
  margin: 4%;
  cursor: pointer;
}
.app .icons li .item:before {
  content: "";
  display: block;
  padding-bottom: 77%;
}
.app .icons li .item .button {
  transform: translate(-50%, -50%);
  position: absolute;
  text-align: center;
  width: 100%;
  left: 50%;
  top: 50%;
}
.app .icons li .item .button .icon {
  margin-top: -10px;
  max-height: 85px;
  height: 14vw;
}
.app .icons li .item .button span {
  font: 1.4em/1 "vigaregular";
  margin: 0 15px;
  display: block;
  color: #fff;
}
.app .icons.col-3 li {
  width: 33%;
}
.app .icons.col-3 li .item:before {
  padding-bottom: 95%;
}
.app .icons.col-3 li .item .button .icon {
  max-height: 75px;
  height: 100%;
  width: 100%;
}
.app .icons.col-3 li .item .button span {
  font: 1.2em/1 "vigaregular";
  margin: -10px 5px 0 5px;
}
@media only screen and (max-width: 320px) {
  .app .icons.col-3 li .item .button .icon {
    max-height: 65px;
    margin-top: -20px;
  }
  .app .icons.col-3 li .item .button span {
    font: 1em/1 "vigaregular";
    margin: -12px 5px 0 5px;
  }
}
.app.opened .icons {
  display: block;
  opacity: 1;
}
.app.opened .rec .rec-pagination {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/menu/MenuList.scss"],"names":[],"mappings":"AAIY;EACI,aAAA;EACA,eAAA;EACA,kBAAA;AAHhB;AAQI;EACI,gCAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;AANR;AAQQ;EACI,UAAA;EACA,WAAA;AANZ;AAQY;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;AANhB;AAQgB;EACI,WAAA;EACA,cAAA;EACA,mBAAA;AANpB;AASgB;EACI,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;AAPpB;AASoB;EACI,iBAAA;EACA,gBAAA;EACA,YAAA;AAPxB;AAUoB;EACI,2BAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;AARxB;AAeY;EACI,UAAA;AAbhB;AAgBoB;EACI,mBAAA;AAdxB;AAmBwB;EACI,gBAAA;EACA,YAAA;EACA,WAAA;AAjB5B;AAoBwB;EACI,2BAAA;EACA,uBAAA;AAlB5B;AAqBwB;EACI;IACI,gBAAA;IACA,iBAAA;EAnB9B;EAqB0B;IACI,yBAAA;IACA,uBAAA;EAnB9B;AACF;AA4BQ;EACI,cAAA;EACA,UAAA;AA1BZ;AA6BY;EACI,cAAA;AA3BhB","sourcesContent":[".app {\n\n    .areas{       \n        .rec{\n            .rec-pagination{\n                display: none;\n                margin-top: -2%;\n                padding-bottom: 4%;\n            }\n        }\n    }\n\n    .icons {\n        transition: opacity 0.6s ease-in;\n        padding-bottom: 10px;\n        margin-top: -19%;\n        overflow: hidden;\n        display: none;\n        padding: 4%;\n        opacity: 0;\n\n        li {\n            width: 50%;\n            float: left;\n\n            .item {\n                background-color: #caa36c;\n                border-radius: 10px;\n                position: relative;\n                display: block;\n                margin: 4%;\n                cursor: pointer;\n\n                &:before {\n                    content: \"\";\n                    display: block;\n                    padding-bottom: 77%;\n                }\n\n                .button {\n                    transform: translate(-50%, -50%);\n                    position: absolute;\n                    text-align: center;\n                    width: 100%;\n                    left: 50%;\n                    top: 50%;\n\n                    .icon {\n                        margin-top: -10px;\n                        max-height: 85px;\n                        height: 14vw;\n                    }\n\n                    span {\n                        font: 1.4em/1 \"vigaregular\";\n                        margin: 0 15px;\n                        display: block;\n                        color: #fff;\n                    }\n                }\n            }\n        }\n\n        &.col-3{\n            li {\n                width: 33%;\n    \n                .item {\n                    &:before {\n                        padding-bottom: 95%;\n                    }\n    \n                    .button {\n    \n                        .icon {\n                            max-height: 75px;\n                            height: 100%;\n                            width: 100%;\n                        }\n    \n                        span {\n                            font: 1.2em/1 \"vigaregular\";\n                            margin: -10px 5px 0 5px;\n                        }\n\n                        @media only screen and (max-width: 320px) { \n                            .icon {\n                                max-height: 65px;\n                                margin-top: -20px;\n                            }\n                            span{\n                                font: 1em/1 \"vigaregular\";\n                                margin: -12px 5px 0 5px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    &.opened {\n        .icons {\n            display: block;\n            opacity: 1;\n        }\n        .rec{\n            .rec-pagination{\n                display: block;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
